/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/ArticlePaywall/Form/theme';

export const ArticlePaywallFormTheme = theme;
